export const createDataFiles = (form) => {
    if ('image' in form) {
        const formdata = new FormData()
        const entries = Object.entries(form)
        entries.some(([key, value]) =>
            formdata.append(key, value)
        )
        return (formdata)
    }
    return form
}

export function capitalize(string) {
    if (string.length === 0) return
    return string[0].toUpperCase() + string.slice(1);
}
export const formatCurrency = (value, lng = 'pt-BR', currency = 'BRL') => {
    const moneyFormated = new Intl.NumberFormat(lng, {
        style: 'currency',
        currency: currency
    }).format(value)
    return moneyFormated
}

export const convertDateFormat = (dateString) => {
    if (/^\d{4}-\d{2}-\d{2}$/.test(dateString)) {
        const date = new Date(dateString);

        const formattedDate = date.toISOString().slice(0, 10);

        return formattedDate;
    } else {
        const date = new Date(dateString);

        const formattedDate = `${date.getFullYear()}-${(date.getMonth() + 1).toString().padStart(2, '0')}-${date.getDate().toString().padStart(2, '0')}`;

        return formattedDate;
    }
}

export const validateDateRange = (dtIni, dtFim, toast) => {
    const ini = new Date(dtIni);
    const fim = new Date(dtFim);

    if (isNaN(ini) || isNaN(fim)) {
        toast.error("Uma das datas é inválida.");
        return true
    }

    if (ini > fim) {
        toast.error("A data inicial não pode ser maior que a data final.");
        return true
    }

    return false
}